
<img src="../../../assets/images/uploadFile.PNG" /><br>
<input #file type="file" multiple (change)="loadFiles()" />

<br/>
<span style="font-weight:bold;color:green;" *ngIf="progress > 0 && progress < 100">
  {{progress}}%
</span>

<span style="font-weight:bold;color:green;" *ngIf="message">
  {{message}}
</span>